import React, { Component } from "react";
import ReactDOMServer from "react-dom/server";

import _ from "lodash";
import moment from "moment";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { bindActionCreators } from "redux";
import * as L from 'leaflet';
import "react-datetime/css/react-datetime.css";

import { getGooglePlaces, toastr, getStorage } from "../../../services/Common.services";
import { getDriverLocationHistoryByLoad } from "../services";
import * as actionCreators from "../Dispatcher/actionCreators";
import { convertTMSStatusName } from "../../../Components/Common/functions";
import { updateDriverOrderById } from "./actionCreator";
import {
  angleFromCoordinate,
  streetTile,
  baseMaps,
  truckIconWithActiveGPS,
  LeafIcon,
} from "../../trucker/NewTrack1/utility.js";
import DriverDetails from "../../trucker/NewTrack1/DriverDetails";
import config from "../../../config";
import ContainerSummary from "../../trucker/NewTrack1/elements/ContainerSummary";
import { RealtimeDBService, REALTIME_DB_SOURCE } from "../../../services/realtimeDB.service";

let mapBreadcrumb;
let locationTimer;
let firstpolyline;
let movingMarker;
const colorCodes = {
  DISPATCHED: "#FF6633",
  CHASSISPICK_ARRIVED: "#FFB399",
  CHASSISPICK_DEPARTED: "#FFB399",
  PULLCONTAINER_ARRIVED: "#FF33FF",
  PULLCONTAINER_DEPARTED: "#FFFF99",
  DELIVERLOAD_ARRIVED: "red",
  DELIVERLOAD_DEPARTED: "#E6B333",
  RETURNCONTAINER_ARRIVED: "#999966",
  RETURNCONTAINER_DEPARTED: "#99FF99",
  CHASSISTERMINATION_ARRIVED: "#B34D4D",
  CHASSISTERMINATION_DEPARTED: "#B34D4D",
  DROPCONTAINER_ARRIVED: "#80B300",
  DROPCONTAINER_DEPARTED: "#809900",
  HOOKCONTAINER_ARRIVED: "blue",
  HOOKCONTAINER_DEPARTED: "blue",
  COMPLETED: "#6680B3",
};

let [currentMap, allMarkers, driverMarker, driverLoad, locationRef, secondaryLocationRef] = [
  undefined,
  [],
  null,
  undefined,
  undefined,
  undefined,
];

let routeControlLayers = [];
const ZOOM_LEVEL_LIMIT = 13;
const zoomMapLayer = new window.L.FeatureGroup();

class LoadHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 250,
      eachTableHeight: window.outerHeight - 685,
      driverLocations: [],
      selectedSliderValue: 0,
      mappedMarkers: [],
      considerLocations: [],
      driverList: [],
      features: [],
      toggleLiveLocation: true,
    };
    this.selectLocation = this.selectLocation.bind(this);
    this.driverLoadAddress = this.driverLoadAddress.bind(this);
    this.addLocationsToMap = this.addLocationsToMap.bind(this);
    this.changeCompleteDate = this.changeCompleteDate.bind(this);
    this.driversTypeGet = this.driversTypeGet.bind(this);
    this.getPlace = this.getPlace.bind(this);
    this.handleChangeSlider = this.handleChangeSlider.bind(this);
  }

  bindMap = () => {
    if (currentMap) {
      currentMap.remove();
      currentMap = new window.L.Map("TrackmapTab", {
        zoom: 8,
        center: [39.011902, -98.484246],
        minZoom: 1,
        zoomOffset: 1,
        layers: [streetTile()],
      });
      currentMap.zoomControl.setPosition("bottomright");
      window.L.control.layers(baseMaps).addTo(currentMap);
    } else {
      let check = true
      const permissionTrack =  document.getElementsByClassName("tracking-permission")
      if(permissionTrack && permissionTrack[0] && permissionTrack[0].innerHTML === "You do not have permission to view this page"){
        check = false
      }
      if(check){
        currentMap = new window.L.Map("TrackmapTab", {
          zoom: 8,
          center: [40.73061, -73.935242],
          minZoom: 1,
          zoomOffset: 1,
          layers: [streetTile()],
        });
        currentMap.zoomControl.setPosition("bottomright");
        window.L.control.layers(baseMaps).addTo(currentMap);
      }
    }


    this.subscribeToLocationChange();

    if (currentMap) {
      currentMap.on("zoomend", (e) => {
        this.zoomHandler(e.target._zoom);
      });
    }

  };

  componentDidMount() {
    const script = document.createElement("script");
    script.src = "/lib/MovingMarker.js";
    script.async = true;
    document.body.appendChild(script);
    this.bindMap();
    this.addLocationsToMap();
    this.setState({ driverList: this.props.driverList }, () => {
      this.driversTypeGet(this.props);
    });
  }

  toggleLiveLocation = (toggle) => {
    this.setState({
      toggleLiveLocation: toggle
    })
  }

  db = config.firebase.database();
  lastLocation = null;
  // subscribe to location change
  subscribeToLocationChange = () => {
    try {
      this.unsubscribeToLocationChange();
      const loadList = this.props.selectedLoads;
      if(loadList && loadList.driverOrderId && loadList.driverOrderId.driver) {
        let loggedInUser = JSON.parse(getStorage("loggedInUser"));

        const carrierId = 
        loggedInUser.role === "carrier"
          ? loggedInUser._id
          : loggedInUser.role === "fleetmanager"
          ? loggedInUser.fleetManager.carrier
          : undefined;

        const refString = `${carrierId}/currentLocation/${loadList.driverOrderId.driver}`;
        locationRef = new RealtimeDBService(REALTIME_DB_SOURCE.primary);
        secondaryLocationRef = new RealtimeDBService(REALTIME_DB_SOURCE.driverLocation);
        locationRef.ref(refString);
        secondaryLocationRef.ref(refString);
        const locationUpdateHandler = (snapshot) => {
          const currentDriverLocation = snapshot.val();

          if(!currentDriverLocation) {
            return;
          }

          if(!driverMarker && currentMap && currentDriverLocation.location) {
            this.lastLocation = currentDriverLocation.location.reverse();
            driverMarker = window.L.Marker.movingMarker(
              [this.lastLocation],
              [],
              {
                id: loadList.driverOrderId.driver,
                icon: truckIconWithActiveGPS,
              }
            ).addTo(currentMap);

            if(this.state.toggleLiveLocation) {
              currentMap.fitBounds([this.lastLocation]);
            }
          } else if(driverMarker && currentMap && currentDriverLocation.location) {
            const currentLocation = currentDriverLocation.location.reverse();
            const rotationAngle = angleFromCoordinate(
              this.lastLocation[0],
              this.lastLocation[1],
              currentLocation[0],
              currentLocation[1],
            );
            driverMarker.moveTo(
              { lat: currentLocation[0], lng: currentLocation[1] },
              6000,
              { rotationAngle: rotationAngle }
            )
            this.lastLocation = currentLocation;
            if(this.state.toggleLiveLocation) {
              currentMap.fitBounds([this.lastLocation]);
            }
          }
        };
        locationRef.on("value", locationUpdateHandler);
        secondaryLocationRef.on("value", locationUpdateHandler);
      }
    } catch(e) {
      console.log("LoadHistoryException: ", e);
    }
  }

  // unsubscribe to location change
  unsubscribeToLocationChange = () => {
    try {
      if(locationRef) {
        locationRef.off();
        locationRef = null;
        if(driverMarker) {
          currentMap.removeLayer(driverMarker);
          driverMarker = null;
        }
      }

      if(secondaryLocationRef) {
        secondaryLocationRef.off();
        secondaryLocationRef = null;
        if(driverMarker) {
          currentMap.removeLayer(driverMarker);
          driverMarker = null
        }
      }
    } catch(e) {
      console.log("LoadHistoryException: ", e);
    }
  }

  componentWillUnmount() {
    this.unsubscribeToLocationChange();
  }

  componentWillReceiveProps(props) {
    this.driversTypeGet(props);
    if (
      (!this.props.selectedLoads && props.selectedLoads) ||
      (this.props.selectedLoads &&
        this.props.selectedLoads != props.selectedLoads)
    ) {
      if (locationTimer) {
        clearInterval(locationTimer);
      }
      this.bindMap();
      this.addLocationsToMap();
    }
  }

  componentDidUpdate(props) {
    if (!_.isEqual(props.driverList, this.props.driverList)) {
      this.setState({ driverList: this.props.driverList }, () => {
        this.driversTypeGet(this.props);
      });
    }
  }

  getTimeDifference = (prevTime, newTime) => {
    let calcTime = "00:00";
    let totalMinutes = moment(newTime).diff(moment(prevTime), "minutes");
    const isNegative = totalMinutes < 0;
    if (isNegative) {
      totalMinutes = totalMinutes * -1;
    }
    let h = Math.floor(totalMinutes / 60);
    let m = totalMinutes % 60;
    if (m == 59) {
      h = h + 1;
      m = 0;
    }
    h = h < 10 ? "0" + h : h;
    m = m < 10 ? "0" + m : m;
    calcTime = h + ":" + m;
    return (
      <span style={{ color: isNegative ? "red" : "" }}>
        {isNegative ? "-" : ""}
        {calcTime}
      </span>
    );
  };

  getPlace = (e, key, textKey) => {
    this.setState({ [textKey]: e.target.value });
    getGooglePlaces(e.target.value).then((response) => {
      let features = response.data.results;
      this.setState({ [key]: features }, () => {});
    });
  };

  onSelect = (place, key, textKey, id) => {
    const address = {
      lat: place.geometry.location.lng,
      lng: place.geometry.location.lat,
      address: place.formatted_address,
    };
    this.setState({ [key]: [], [textKey]: "" });
    this.changeCompleteDate(id, undefined, undefined, address);
  };

  selectLocation(data) {
    let address = data.address;
    if (address && mapBreadcrumb) {
      mapBreadcrumb.flyTo([address.lat, address.lng], 18);
    }
  }

  driversTypeGet(props) {
    if (props.selectedLoads) {
      const groupedStatuses = props.selectedLoads.statusOrder.groupBy(function (
        n
      ) {
        return n.type;
      });
      const pullContainerDriver =
        groupedStatuses["PULLCONTAINER"] &&
        groupedStatuses["PULLCONTAINER"][0] &&
        groupedStatuses["PULLCONTAINER"][0].driver
          ? groupedStatuses["PULLCONTAINER"][0].driver._id
          : -1;
      const deliverLoadDriver =
        groupedStatuses["DELIVERLOAD"] &&
        groupedStatuses["DELIVERLOAD"][0] &&
        groupedStatuses["DELIVERLOAD"][0].driver
          ? groupedStatuses["DELIVERLOAD"][0].driver._id
          : -1;
      const dropAtYardDriver =
        groupedStatuses["DROPYARD"] &&
        groupedStatuses["DROPYARD"][0] &&
        groupedStatuses["DROPYARD"][0].driver
          ? groupedStatuses["DROPYARD"][0].driver._id
          : -1;
      const returnContainerDriver =
        groupedStatuses["RETURNCONTAINER"] &&
        groupedStatuses["RETURNCONTAINER"][0] &&
        groupedStatuses["RETURNCONTAINER"][0].driver
          ? groupedStatuses["RETURNCONTAINER"][0].driver._id
          : -1;
      this.setState({
        PULLCONTAINER: pullContainerDriver,
        DELIVERLOAD: deliverLoadDriver,
        DROPYARD: dropAtYardDriver,
        RETURNCONTAINER: returnContainerDriver,
      });
    }
  }

  addLocationsToMap() {
    if (this.props.selectedLoads) {
      getDriverLocationHistoryByLoad({
        loadRef: encodeURIComponent(this.props.selectedLoads.reference_number),
      }).then((response) => {
        const oneDotPoints = parseInt(response.data.data.length / 10);
        const sliderLables = {};
        if (oneDotPoints > 1) {
          for (let k = 0; k < 10; k++) {
            const time = moment(
              response.data.data[k * oneDotPoints].createdAt
            ).format("LT");
            sliderLables[k * oneDotPoints] = time;
          }
          sliderLables[response.data.data.length] = moment(
            response.data.data[response.data.data.length - 1].createdAt
          ).format("LT");
        }
        this.setState(
          {
            driverLocations: response.data.data,
            sliderLables,
            startIndexSlider: 0,
            stopIndexSlider: response.data.data.length,
          },
          () => {
            let LeafIcon = window.L.Icon.extend({
              options: {
                iconSize: [13, 50],
              },
            });
            var greenIcon = new LeafIcon({ iconUrl: "/assets/img/truck.png" });
            const groupedLocation = this.state.driverLocations.groupBy((n) => {
              return n.loadStatus;
            });
            Object.keys(groupedLocation).forEach((key, i) => {
              const driverLatlongs = [];
              const centerLocation = [];
              groupedLocation[key].forEach((obj) => {
                centerLocation.push([obj.location[1], obj.location[0]]);
                driverLatlongs.push(
                  new window.L.LatLng(obj.location[1], obj.location[0])
                );
              });
              if (i === 0) {
                try {
                  movingMarker = window.L.Marker.movingMarker(
                    [driverLatlongs[0]],
                    [],
                    { icon: greenIcon }
                  ).addTo(mapBreadcrumb);
                } catch (err) {}
              }
              if (driverLatlongs.length > 0 && mapBreadcrumb) {
                const firstpolyline = new window.L.Polyline(driverLatlongs, {
                  color: colorCodes[key],
                  weight: 7,
                  opacity: 1,
                  smoothFactor: 1,
                });
                firstpolyline.addTo(mapBreadcrumb);
                setTimeout(() => {
                  mapBreadcrumb.fitBounds([centerLocation]);
                }, 2000);
              }
            });
          }
        );
      });
    }
  }

  loadMap = () => {
    const loadInfo = this.props.selectedLoads;
    let allLocations = [];
    let centerLocation = [];

    if (mapBreadcrumb) {
      mapBreadcrumb.remove();
      mapBreadcrumb = undefined;
    }

    var satelliteTile = L.tileLayer(
      "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
      {
        maxZoom: 19,
      }
    );
    var placeTile = L.tileLayer(
      "https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}",
      {
        maxZoom: 19,
      }
    );
    var transportTile = L.tileLayer(
      "https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}",
      {
        maxZoom: 19,
      }
    );
    var LeafIcon = window.L.Icon.extend({
      options: {
        iconSize: [12, 20],
      },
    });
    if (!window.L) {
      return;
    }
    var greenIcon = new LeafIcon({ iconUrl: "/assets/img/Small_Pin.png" });
    let breadcrumb1 = document.getElementById("breadcrumb1");
    if (breadcrumb1) {
      mapBreadcrumb = new window.L.Map("breadcrumb1", {
        minZoom: 1,
        zoomOffset: 1,
      });
      mapBreadcrumb.addLayer(satelliteTile);
      mapBreadcrumb.addLayer(transportTile);
      mapBreadcrumb.addLayer(placeTile);
      if (loadInfo) {
        loadInfo.statusOrder.forEach((element) => {
          if (
            element.address &&
            element.address.lat !== 0 &&
            element.address.lng !== 0
          ) {
            allLocations.push(
              new window.L.LatLng(element.address.lat, element.address.lng)
            );
            allMarkers.push({
              status: convertTMSStatusName(
                loadInfo.type_of_load,
                element.status
              ),
              location: [element.address.lat, element.address.lng],
            });
            centerLocation.push([element.address.lat, element.address.lng]);
          }
        });
      }
      allMarkers.forEach((obj) => {
        window.L.marker(obj.location, { icon: greenIcon })
          .bindPopup(convertTMSStatusName(loadInfo.type_of_load, obj.status))
          .addTo(mapBreadcrumb);
      });
      if (centerLocation.length > 0) mapBreadcrumb.fitBounds([centerLocation]);
    }
  };

  driverLoadAddress(status) {
    const selectedLoad = this.props.selectedLoads;
    if (selectedLoad && selectedLoad.statusHistory) {
      return selectedLoad.statusHistory.find((obj) => {
        return obj.newStatus === status;
      });
    } else {
      return undefined;
    }
  }

  handleChangeSlider(value) {
    this.setState(
      {
        selectedSliderValue: value,
      },
      () => {
        if (movingMarker && mapBreadcrumb) {
          const previousLocation = this.state.driverLocations[value - 1];
          const obj = this.state.driverLocations[value];
          if (obj) {
            let rotationAngle = 0;
            if (previousLocation) {
              rotationAngle = angleFromCoordinate(
                previousLocation.location[1],
                previousLocation.location[0],
                obj.location[1],
                obj.location[0]
              );
            }
            movingMarker.moveTo(
              new window.L.LatLng(obj.location[1], obj.location[0]),
              100,
              { rotationAngle: rotationAngle }
            );
            mapBreadcrumb.fitBounds(
              [new window.L.LatLng(obj.location[1], obj.location[0])],
              { maxZoom: mapBreadcrumb.getZoom() }
            );
          }
        }
      }
    );
  }

  changeCompleteDate(driverOrderId, timeOfStatus, status, address) {
    const { selectedLoads } = this.props;
    const formData = new FormData();
    formData.append(
      "reference_number",
      selectedLoads && selectedLoads.reference_number
    );
    formData.append("driverOrderId", driverOrderId);
    formData.append("arrivedOrDeparted", status);
    formData.append("date", moment(timeOfStatus).toISOString());
    formData.append("strictChange", true);

    updateDriverOrderById(formData)
      .then((result) => {
        this.setState({ [`${driverOrderId}_calendar_${status}`]: undefined });
        toastr.show("You have updated the status!", "success");
      })
      .catch((err) => {
        toastr.show("The update has failed.  Please try again.", "error");
        console.log("Error ------", err);
      });
  }

  addLocationsToMap1 = (log) => {
    const driverLatlongs = [];
    const centerLocation = [];
    let allMarkers = [];
    let mappedMarkers = [];
    var LeafIcon = window.L.Icon.extend({
      options: {
        iconSize: [5, 5],
      },
    });
    var greenIcon = new LeafIcon({ iconUrl: "/assets/img/Small_Pin.png" });

    log.forEach((obj) => {
      centerLocation.push([obj.location[1], obj.location[0]]);
      allMarkers.push({
        status: obj.loadStatus ? obj.loadStatus : obj.eldDtatus,
        location: [obj.location[1], obj.location[0]],
      });

      driverLatlongs.push(
        new window.L.LatLng(obj.location[1], obj.location[0])
      );
    });

    allMarkers.forEach((obj) => {
      let i = window.L.marker(obj.location, { icon: greenIcon })
        .bindPopup(
          convertTMSStatusName(
            this.props.selectedLoads.type_of_load,
            obj.status
          )
        )
        .addTo(mapBreadcrumb);
      mappedMarkers.push(i);
    });
    this.setState({ mappedMarkers });
    if (driverLatlongs.length > 0 && mapBreadcrumb) {
      firstpolyline = new window.L.Polyline(driverLatlongs, {
        color: "#A5DB03",
        weight: 5,
        opacity: 1,
        smoothFactor: 1,
      });
      firstpolyline.addTo(mapBreadcrumb);
      setTimeout(() => {
        mapBreadcrumb.fitBounds([centerLocation]);
      }, 2000);
    } else {
      this.state.mappedMarkers.forEach((e) => {
        mapBreadcrumb.removeLayer(e);
      });
      if (firstpolyline) {
        mapBreadcrumb.removeLayer(firstpolyline);
      }
    }
  };

  resetMap = () => {
    // TODO: add reset map logic
  };

  clearAllRoutes = () => {
    if (routeControlLayers.length) {
      for (const routeL in routeControlLayers) {
        routeControlLayers[routeL].remove();
      }
      routeControlLayers = [];
    }
  };

  drawRouteToMap = (routes) => {
    this.clearAllRoutes();
    zoomMapLayer.clearLayers();
    if (routes && routes.routes) {
      for (const key in routes.routes) {
        const route = routes.routes[key];
        const index = routeControlLayers.length;
        routeControlLayers.push(route);
        currentMap.addControl(routeControlLayers[index]);
      }
    }

    // Display company name marker on the screen
    if (routes.companyNames) {
      for (const key in routes.companyNames) {
        zoomMapLayer.addLayer(routes.companyNames[key]);
        
        const summaryComponent = ReactDOMServer.renderToString(
          <div className="position-relative">
            <ContainerSummary />
          </div>
        );
        
  
        // Marker
        const driverLatlongs = routes.companyNames[key]._latlng;
        var greenIcon = new LeafIcon({ iconUrl: "/assets/img/Small_Pin.png" });
        var marker = window.L.marker([driverLatlongs.lat, driverLatlongs.lng], {icon: greenIcon}).bindPopup(summaryComponent, {closeOnClick: false, autoClose: false}).addTo(currentMap);
        marker.openPopup();
        console.log(marker, "marker===============")
      }

    }

    if (routes.boundsToFit.length > 0) {
      currentMap.fitBounds(routes.boundsToFit, {
        padding: [500, 50],
      });
    }

  };

  zoomHandler = (zoomLevel) => {
    if (zoomLevel >= ZOOM_LEVEL_LIMIT) {
      if (currentMap) {
        currentMap.addLayer(zoomMapLayer);
      }
    } else {
      if (currentMap) {
        currentMap.removeLayer(zoomMapLayer);
      }
    }
  };

  renderReturn = () => {
    const selectedLoad = this.props.selectedLoads;
    let { selectedSliderValue, driverList } = this.state;
    if (driverList && driverList.length > 0) {
      driverList = driverList.filter(
        (D) => D.driver && D.driver.isDeleted === false
      );
    }

    return (
      <React.Fragment>
        <div className="tab" style={{height: 'calc(100vh - 196px)'}}>
          <DriverDetails
            allLoads={this.props.selectedLoads}
            drawRouteToMap={this.drawRouteToMap}
            mapInstance={currentMap}
            toggleLiveLocation={this.toggleLiveLocation}
            liveLocationToggled={this.state.toggleLiveLocation}
          />
          <div
            className="tab__track-map"
            id="TrackmapTab"
            style={{
              height: `calc(100vh - 60px})`,
            }}
          ></div>
        </div>
      </React.Fragment>
    );
  
  };

  render() {
    const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
    if (loggedInUser)
      if (
        loggedInUser.role === "carrier" ||
        loggedInUser.role === "customer" ||
        loggedInUser.role === "fleetcustomer"
      )
        return this.renderReturn();
      else if (loggedInUser.permissions.length !== 0)
        if (
          loggedInUser.permissions.includes("customer_service_tracking") ||
          (loggedInUser.role === "fleetmanager" &&
            loggedInUser.fleetManager.isCustomer &&
            loggedInUser.permissions.includes("customer_employee_load_tracking"))
        )
          return this.renderReturn();
        else
          return (
            <div className="nopermission">
              <h1 className="tracking-permission">You do not have permission to view this page</h1>
            </div>
          );
      else
        return (
          <div className="nopermission">
            <h1 className="tracking-permission">You do not have permission to view this page</h1>
          </div>
        );
  }
}

function _toDeg(rad) {
  return (rad * 180) / Math.PI;
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actionCreators, dispatch),
  };
}

const states = (state) => ({
  driverList: state.TmsReducer.drivers,
});

LoadHistory = reduxForm({
  // a unique name for the form
  form: "tmsloadHistoryedit",
  enableReinitialize: true,
})(LoadHistory);
export default connect(states, mapDispatchToProps)(LoadHistory);
